import React, { Fragment, useContext, useEffect, useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom'

import { SiteContext } from '../../../context/SiteContext';
import { UserContext } from '../../../context/UserContext';
import { formatHeaders } from '../../../utils/tables';
import Table from '../../../components/system/Table';

import Filters, { applyFilters } from './Filters';
import Modal from 'react-bootstrap/Modal';
import TaskNew from './TaskNew';
import TaskEdit from './TaskEdit';

const View = () => {
  const { config } = useContext(SiteContext);
  const { allUsers, schemas, tasks, setTasks } = useContext(UserContext);
  const { project, projTasks, phases, phasePlans, activePhase, planGroups, plans, types, typeVars, libraries, symbols, activePlots, activeQtys, activePhotos, publicStatuses } = useOutletContext();

  const [filters, setFilters] = useState([]);
  const [search, setSearch] = useState();
  const activeData = useMemo(() => applyFilters(projTasks, filters, search), [projTasks, filters, search]);

  const [headers, setHeaders] = useState([]);

  const [active, setActive] = useState({});
  const [show, setShow] = useState(false);
  const handleCancel = () => {
    setShow(false);
    setActive({});
  }

  const clicked = (e) => {
    let found = projTasks.find(x => x.id === e.original.id);
    if(!found) return;
    setActive(found);
    setShow(true);
  }

  useEffect(() => {
    let found = schemas.find(x => x.type === 'headers' && x.name === 'task-project');
    if(!found) return;
    let headers = formatHeaders(found.schema, { allUsers });
    setHeaders(headers);
  }, [schemas, allUsers])

  return (
    <Fragment>
      <div className="row h-100 overflow-hidden">
        <div className="col-sm-12 h-100 overflow-scroll">
          <div className="mb-3 p-3 bg-white rounded">
            <div className="mb-2">
            <Filters search={search} setSearch={setSearch} filters={filters} setFilters={setFilters} />
              <div className="float-end"><TaskNew parentType="project" parent={project} parentId={project.id} phases={phases} activePhase={activePhase} modalText={{ button: `Create  ${config?.terms?.task?.[2] ?? 'Task'}`, title: 'Create New' }} /></div>
            </div>
            <Table columns={headers} data={activeData} onRowClicked={clicked} classes="table table-sm table-hover my-0" rowClasses="pointer" noDataMsg={`No ${config?.terms?.task?.[1] ?? 'tasks'} for this ${config?.terms?.project?.[0] ?? 'project'} yet.`} />
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleCancel} size='lg' backdrop='static' keyboard={true} scrollable>
        <TaskEdit parentType="project" parent={project} pieces={{ planGroups, plans, phasePlans, activePhase, types, typeVars, libraries, symbols, activePlots, activeQtys, activePhotos, publicStatuses }} obj={active} setObj={setActive} handleCancel={handleCancel} tasks={tasks} setTasks={setTasks} phases={phases} />
      </Modal>
    </Fragment>
  )
}

export default View;
